import * as actions from './actions';
import reducers from './reducer';

export const Conversations = { actions, reducers };
export { ConversationState } from './reducer';
